import { render, staticRenderFns } from "./conversation-container.vue?vue&type=template&id=6e1a3790&scoped=true&"
import script from "./conversation-container.vue?vue&type=script&lang=js&"
export * from "./conversation-container.vue?vue&type=script&lang=js&"
import style0 from "./conversation-container.vue?vue&type=style&index=0&id=6e1a3790&prod&lang=less&scoped=true&"
import style1 from "./conversation-container.vue?vue&type=style&index=1&id=6e1a3790&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1a3790",
  null
  
)

export default component.exports